import LogoutConfimationPopup from './LogoutConfimationPopup';

export default LogoutConfimationPopup;
